import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';

import {Article} from '../../../../core/models/articles/articles.model';
import {Institution} from '../../../../core/models/institutions/institutions.model';
import {Topic} from '../../../../core/models/topics/topics.model';
import {ArticlesService} from '../../../../core/services/articles/articles.service';
import {InstitutionsService} from '../../../../core/services/institutions/institutions.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {TopicsService} from '../../../../core/services/topics/topics.service';
import {splitTopics} from '../../../../core/utils/topics.helper';
import {clientRoles} from "../../../../core/constants/client-roles.config";

@Component({
  selector: 'app-edit-article',
  templateUrl: './edit-article.component.html',
  styleUrls: ['./edit-article.component.css'],
  standalone: false,
})
export class EditArticleComponent implements OnInit, OnDestroy {
  @ViewChild('articleFormComponent') articleForm: any;

  private paramsSub!: Subscription;
  private articleId!: string;
  protected article!: Article;
  public topics!: Topic[];
  public subjectAreas!: Topic[];
  public institutions!: Institution[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private topicsService: TopicsService,
    private institutionsService: InstitutionsService,
    private toastService: ToastService,
  ) {
  }

  public ngOnInit(): void {
    this.topicsService.getAll({
      select: ['name', 'englishName', 'kind', 'isSubjectArea'],
    }).subscribe(res => {
      const split = splitTopics(res.docs);
      this.topics = split.topics;
      this.subjectAreas = split.subjectAreas;
    });
    this.getInstitutions();

    this.paramsSub = this.route.params.subscribe((params) => {
      this.articleId = params.id;
      this.getArticle();
    });
  }

  public ngOnDestroy(): void {
    this.paramsSub.unsubscribe();
  }

  private getArticle() {
    this.articlesService.getOne(this.articleId, ' ').subscribe((article: Article) => {
      this.article = article;
      this.mergeChanges(article);
      this.articleForm.updateValues(this.article);
    });
  }

  saveArticle(publish?: boolean): void {
    const article = Object.assign(this.article, this.articleForm.getValues());
    if (publish) {
      article.isDraft = false;
    }
    this.articlesService.updateOne(article, this.articleId).subscribe(() => {
      this.router.navigate(['../..'], {relativeTo: this.route});
      if (publish) {
        this.toastService.success(
          $localize`:@@edit-article-publish-success-title:Artikel bearbeitet und veröffentlicht`,
          $localize`:@@edit-article-publish-success-message:Der Artikel wurde erfolgreich bearbeitet und veröffentlicht.`,
        );
      } else {
        this.toastService.success(
          $localize`:@@edit-article-success-title:Artikel bearbeitet`,
          $localize`:@@edit-article-success-message:Der Artikel wurde erfolgreich bearbeitet.`,
        );
      }
    }, error => {
      this.toastService.error($localize`:@@edit-article-error-title:Artikel nicht bearbeitet`, $localize`:@@edit-article-error-message:Der Artikel konnte nicht bearbeitet werden.`, error);
    });
  }

  private getInstitutions() {
    this.institutionsService.getAll({
      select: ['name'],
    }).subscribe((instData) => {
      this.institutions = instData.docs;
    });
  }

  mergeChanges(article: Article) {
    if (!article.changelog) return;
    for (const change of article.changelog) {
      for (let i = 0; i < change.diff.length; i++) {
        if (change.diff[i].op === 'test' && i + 1 < change.diff.length) {
          change.diff[i + 1].before = change.diff[i].value;
          change.diff.splice(i, 1);
        }
      }
    }
    article.changelog.reverse();
  }

  protected readonly clientRoles = clientRoles;
}
